import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/currency';
import styles from './testimonials.module.less';

const TestimonialTile = ({ content, author, bgColor, position }) => {
  const style = bgColor ? { backgroundColor: bgColor } : {};
  return (
    <div className={styles.testimonialTileContainer} style={style}>
      <Text size="small">{content}</Text>
      <div className={styles.testimonialTileAuthor}>
        <Text bold>{author}</Text>
        <Text size="x-small">{position}</Text>
      </div>
    </div>
  );
};

TestimonialTile.displayName = 'TestimonialTile';

TestimonialTile.propTypes = {
  content: PropTypes.string,
  author: PropTypes.string,
  bgColor: PropTypes.string,
  position: PropTypes.string,
};

export default TestimonialTile;
